var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"toast-fade"}},[(_vm.toast.isShow)?_c('div',{staticClass:"toast"},[_c('pre',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.toast.text))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }